//angular imports
import {
    ChangeDetectionStrategy,
    Component, 
    WritableSignal, 
    signal,
} from '@angular/core';

//local imports
import { PresenterType } from '@shared/components';
import { ProgramAlreadyExistsMessage } from './program-already-exists.message';

@PresenterType(
{
    model: ProgramAlreadyExistsMessage
})
@Component({
    selector: 'program-already-exists-message-template',
    templateUrl: './program-already-exists-message-template.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ProgramAlreadyExistsMessageTemplateComponent
{
    public data: WritableSignal<ProgramAlreadyExistsMessage>;
    
    constructor() {
        this.data = signal<ProgramAlreadyExistsMessage>(null);
    }
}